/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const windowLogId = 'rendererLog';
export const showWindowLogActionId = 'workbench.action.showWindowLog';
